// extracted by mini-css-extract-plugin
export default {"link":"Link_link__lXwyG","buttonLink":"Link_buttonLink__PRi-G"};